// extracted by mini-css-extract-plugin
export default {"verses":"verses_verses__72yH-"};